import { Box, makeStyles, Typography } from "@material-ui/core"
import React from "react"
import { LIGHT_GRAY_COLOR, SECONDARY_COLOR } from "../../theme"

const LinkButton = (props) => {
	const { label, icone, desabilitado, onClick, className, fontSize } = props
	const classes = useStyles({
		linkButtonDesabilitado: desabilitado,
		fontSize: fontSize
	})

	return (
		<Box className={`${!desabilitado && "pointer"} ${classes.containerLinkButton} ${className}`} onClick={(desabilitado ? null : onClick)}>
			{icone}
			<Typography variant="body2" className={`${classes.linkButton} ml-2`}>
				{label}
			</Typography>
		</Box>
	)
}

const useStyles = makeStyles(() => ({
	linkButton: (props) => ({
		color: props.linkButtonDesabilitado ? LIGHT_GRAY_COLOR : SECONDARY_COLOR,
		fontWeight: "bold",
		fontSize: props.fontSize
	}),
	containerLinkButton: {
		display: "flex",
		alignItems: "center"
	},
}))

export default LinkButton
